import { ChainId } from '@pancakeswap/chains'
import { CHAINS } from './chains'


export const SERVER_NODES = CHAINS.reduce(
  (nodes, chain) => ({ ...nodes, [chain.id as ChainId]: chain.rpcUrls.public.http }), 
  {} as Record<ChainId, readonly string[]>
)

export const PUBLIC_NODES = SERVER_NODES
